import React,{useRef } from "react";
import {Navbar,Footer} from '../hrcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import {useReactToPrint} from 'react-to-print';

const AttnReport=()=>{

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }

    const componentRef = useRef();

    const [attenData,setSearchData]=useState([]);
    const [filter, setFilter] = useState(attenData);
    const [attenDataSum,setSearchDataSum]=useState([]);
    const [noResults, setNoResults] = useState(false);
    const [aCount,setCount]=useState(0);
    const [dataSumTotal,setDataSumTotal]=useState([]);
    const [departments,setDepartment]=useState([]);

    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split('T')[0];
        });

    useEffect(() => {
    const getDepartment = async () => {
        const response=await axios.get(configData.SERVER_URL+`/departments/${localStorage.getItem('branchID')}`)
        setDepartment(response.data);
    };
    getDepartment();

    }, []);

    const handleSubmit=async(e)=>{
    e.preventDefault();

    if (!startDate) {
        alert('Dates required.');
        return;
    }   

    try {
      const res = await axios.get(configData.SERVER_URL+`/attenReport/${startDate}/${startDate}/${localStorage.getItem('branchID')}`);
      setSearchData(res.data.data);
      setFilter(res.data.data);
      setSearchDataSum(res.data.dataSum);
      setDataSumTotal(res.data.dataSumTotal);
      

      if (res.data.length === 0) {
        setNoResults(true);
      } else {
        setNoResults(false);
      }
    } catch (error) {
      console.error('Search error:', error);
    }   
  }

  const filterData = (e) => {
    if(Number(e.target.value)===0){
      setFilter(attenData);
    }
    else{
      const updatedList=attenData.filter(fData=>fData.deptID===Number(e.target.value));
      setFilter(updatedList);
    }
  }

  const printDiv = (printDiv) => {

    const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    return(
      <>
      <div className='container'>

        <div className="card shadow-sm border-0">
  <div className="card-body bg-primary bg-opacity-25 rounded">

    {/* Title */}
    <h4 className="fw-bold text-primary mb-4 d-flex align-items-center">
      <Icon.CalendarCheck className="me-2" />
      Attendance Report
    </h4>

    {/* Form Row */}
    <div className="row g-3 align-items-end">

      {/* Start Date */}
      <div className="col-lg-3 col-md-4 col-sm-6">
        <label className="form-label fw-semibold">
          Start Date
        </label>

        <input
          type="date"
          className="form-control shadow-sm"
          name="startDate"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{
            height: "45px",
            borderRadius: "10px",
          }}
        />
      </div>

      {/* Search Button */}
      <div className="col-lg-2 col-md-3 col-sm-6">
        <button
          type="button"
          className="btn btn-success w-100 shadow-sm d-flex align-items-center justify-content-center"
          onClick={handleSubmit}
          style={{
            height: "45px",
            borderRadius: "10px",
            fontWeight: "600",
          }}
        >
          <Icon.Search className="me-2" />
          Search
        </button>
      </div>

    </div>
  </div>
        </div>

        {noResults && <p class="text-center" >No results found.</p>}
        
        <div className="row py-4" ref={componentRef}>
        <div className="col-12">

    {/* Card */}
    <div
      className="card border-0 shadow-lg"
      style={{
        borderRadius: "18px",
        overflow: "hidden",
      }}
      id="cardAttenSummary"
    >

      {/* Header */}
      <div
        className="card-header bg-info text-white d-flex align-items-center justify-content-between"
        style={{
          padding: "16px 20px",
        }}
      >
        <h5 className="mb-0 fw-bold">
          Attendance Summary
        </h5>

        <small className="opacity-75">
          Report View
        </small>
      </div>

      {/* Body */}
      <div
        className="card-body"
        style={{
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="table-responsive">

          <table className="table table-hover table-bordered align-middle text-center">

            {/* Table Head */}
            <thead className="table-success">
              <tr>
                <th>Department</th>
                <th>Date</th>
                <th>Total</th>
                <th>Present</th>
                <th>Present %</th>
                <th>Late</th>
                <th>Late %</th>
                <th>Leave</th>
                <th>Leave %</th>
                <th>Absent</th>
                <th>Absent %</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {attenDataSum &&
                attenDataSum.length > 0 &&
                attenDataSum.map((data, index) => (
                  <tr key={index}>
                    <td className="fw-semibold text-start">
                      {data.deptName}
                    </td>

                    <td>
                      {format(
                        new Date(data.eventDate),
                        "dd-MM-yyyy"
                      )}
                    </td>

                    <td>{data.total_emp}</td>

                    <td className="text-success fw-bold">
                      {data.present_count}
                    </td>

                    <td>
                      {data.present_Per}%
                    </td>

                    <td className="text-warning fw-bold">
                      {data.late_count}
                    </td>

                    <td>{data.late_Per}%</td>

                    <td className="text-primary fw-bold">
                      {data.leave_count}
                    </td>

                    <td>{data.leave_Per}%</td>

                    <td className="text-danger fw-bold">
                      {data.absent_count}
                    </td>

                    <td>{data.absent_Per}%</td>
                  </tr>
                ))}
            </tbody>

            {/* Footer */}
            <tfoot className="table-dark">
              {dataSumTotal &&
                dataSumTotal.length > 0 &&
                dataSumTotal.map((data, index) => (
                  <tr key={index} className="fw-bold">
                    <td>Total</td>

                    <td>
                      {format(
                        new Date(data.eventDate),
                        "dd-MM-yyyy"
                      )}
                    </td>

                    <td>{data.total_emp}</td>

                    <td>{data.present_count}</td>

                    <td>{data.present_Per}%</td>

                    <td>{data.late_count}</td>

                    <td>{data.late_Per}%</td>

                    <td>{data.leave_count}</td>

                    <td>{data.leave_Per}%</td>

                    <td>{data.absent_count}</td>

                    <td>{data.absent_Per}%</td>
                  </tr>
                ))}
            </tfoot>

          </table>
        </div>
      </div>
    </div>
        </div>
        </div>

        <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4" id="printDiv_AttnDetails">

            {/* Card Header */}

            <div className="card-header bg-success text-white py-3 px-4" >

              <div className="row align-items-center">

                <div className="col-lg-6">
                  <h5 className="mb-0 fw-bold">
                    <Icon.PeopleFill className="me-2" />
                    Attendance Details
                  </h5>

                  <button  type="button" className="btn btn-light"
                        onClick={()=>printDiv("printDiv_AttnDetails")}
                        style={{ borderRadius: "50px", padding: "10px 18px", fontWeight: "600",}}
                      >
                        <Icon.Printer className="me-2" />
                        Print
                      </button>
                </div>

                <div className="col-lg-4 col-md-6 ms-auto">

                  <label className="form-label fw-semibold mb-1">
                    <Icon.Filter className="me-1" />
                    Department Filter
                  </label>

                  <select
                    className="form-select shadow-sm"
                    id="deptName"
                    name="deptName"
                    onChange={(e) => filterData(e)}
                  >
                    <option value={0}>--- ALL DEPARTMENTS ---</option>

                    {departments.map((dept) => (
                      <option key={dept.id} value={dept.id}>
                        {dept.deptName}
                      </option>
                    ))}
                  </select>

                </div>

              </div>

            </div>

            {/* Card Body */}

            <div
              className="card-body table-responsive"
              style={{
                backgroundColor: "#f8f9fa",
                padding: "20px",
              }}
            >

              <table className="table table-hover table-bordered align-middle">

                {/* Table Header */}

                <thead
                  className="table-success"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <tr className="text-center">

                    <th style={{ minWidth: "70px" }}>SL</th>
                    <th style={{ minWidth: "180px" }}>Department</th>
                    <th style={{ minWidth: "120px" }}>Emp Code</th>
                    <th style={{ minWidth: "220px" }}>Employee Name</th>
                    <th style={{ minWidth: "120px" }}>Date</th>
                    <th style={{ minWidth: "120px" }}>In Time</th>
                    <th style={{ minWidth: "120px" }}>Out Time</th>
                    <th style={{ minWidth: "140px" }}>Remarks</th>
                    <th style={{ minWidth: "220px" }}>Description</th>

                  </tr>
                </thead>

                {/* Table Body */}

                <tbody>

                  {filter && filter.length > 0 ? (

                    filter.map((data, index) => (

                      <tr key={index} className="text-center">

                        <td className="fw-bold">
                          {index + 1}
                        </td>

                        <td className="text-start">
                          {data.deptName}
                        </td>

                        <td>
                          <span className="badge bg-primary">
                            {data.empCode}
                          </span>
                        </td>

                        <td className="text-start fw-semibold">
                          {data.empName}
                        </td>

                        <td>
                          {format(data.eventDate, "dd-MM-yyyy")}
                        </td>

                        <td className="text-success fw-bold">
                          {data.entryTime}
                        </td>

                        <td className="text-danger fw-bold">
                          {data.exitTime}
                        </td>

                        <td>

                          <span
                            className={`badge ${
                              data.remarks === "Present"
                                ? "bg-success"
                                : data.remarks === "Late"
                                ? "bg-warning text-dark"
                                : data.remarks === "Absent"
                                ? "bg-danger"
                                : "bg-secondary"
                            }`}
                          >
                            {data.remarks}
                          </span>

                        </td>

                        <td className="text-start">
                          {data.description}
                        </td>

                      </tr>

                    ))

                  ) : (

                    <tr>
                      <td colSpan="9" className="text-center py-4 text-muted">
                        <Icon.ExclamationCircle className="me-2" />
                        No attendance records found.
                      </td>
                    </tr>

                  )}

                </tbody>

              </table>

            </div>

            {/* Footer */}

            <div className="card-footer bg-light text-muted small d-flex justify-content-between">

              <span>
                Total Records: <strong>{filter?.length || 0}</strong>
              </span>

              <span>
                MIS & ICT Division
              </span>

            </div>

        </div>

      </div>
      </>
    )

}

export default AttnReport;